import { render, staticRenderFns } from "./voicemail-settings.vue?vue&type=template&id=dc0be0e8&"
import script from "./voicemail-settings.vue?vue&type=script&lang=js&"
export * from "./voicemail-settings.vue?vue&type=script&lang=js&"
import style0 from "./voicemail-settings.vue?vue&type=style&index=0&id=dc0be0e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports